(function(){
    'use strict'

    angular.module('app.archivoAsociacion')
    .factory('ArchivoAsociacionService', ArchivoAsociacionService);

    ArchivoAsociacionService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function ArchivoAsociacionService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            search: search,
            getProcesoInfo: getProcesoInfo,
            save: save,
            update:update,
            remove: remove,
            uploadFile: uploadFile
        };

        return api;

        function getAll(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/archivos-asociacion/get-all/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function search(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivos-asociacion/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function getProcesoInfo(calendarizacionId){

            var url = apiSettings.apiBaseUrl + 'api/archivos-asociacion/proceso/' + UserInfoService.getCompaniaId() + '/' + calendarizacionId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(record){

            banco.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivos-asociacion',  
                method: 'POST',  
                data: record
            });  
            return response;
        };

        function update(record){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivos-asociacion',  
                method: 'PUT',  
                data: record
            });  
            return response;
        };

        function remove(record){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/archivos-asociacion',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: record
            });  
            return response;
        };

        function uploadFile(file, calendarizacionId){

            //FormData, object of key/value pair for form fields and values
            var fileFormData = new FormData();
            fileFormData.append('companiaId', UserInfoService.getCompaniaId());
            fileFormData.append('calendarizacionId', calendarizacionId);
            fileFormData.append('file', file);


            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/cargar-archivo-asociacion',  
                method: 'POST',  
                data: fileFormData,
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            });  
            return response;
        };

    };

})();